// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Wl3l","productName":"Table_productName__eGfs4"};